import React, { Fragment } from "react";
import { Card, Col, Row } from 'react-bootstrap';
import '../../../../styles/diario.scss'

const Profissional = (props) => {

    return (
        <Fragment>
            <Col>
                <Card className="card-list">
                    {props.prof.foto ? <img className="foto-prof" src={props.prof.foto} /> : null }
                    <Card.Header><h5>{props.prof.nome} / {props.prof.especialidade}</h5></Card.Header>
                    <Card.Body>
                        <Row xs={3}>
                            <Col xs={6}>
                                <p>Local de Atendimento:</p>
                            </Col>
                            <Col>
                                <p>Dia:</p>
                            </Col>
                            <Col>
                                <p>Horários:</p>
                            </Col>
                        </Row>
                        <Row xs={12} lg={3}>
                            {props.prof.locais.map((local, index) =>
                                <p className="produtos-rel">{local.local} - {local.dia} - {local.horarios}</p>
                            )}
                        </Row>
                    </Card.Body>   
                </Card>
            </Col>
        </Fragment >)
}

export default Profissional;